
import {Component, Prop, Vue} from 'vue-property-decorator';
import TarafKisi from '@/plugins/uyap-plugin/takip_ac/parser/TarafKisi';
import TarafKurum from '@/plugins/uyap-plugin/takip_ac/parser/TarafKurum';

@Component
export default class TarafBadges extends Vue {
  @Prop({required: true}) readonly taraf!: TarafKisi | TarafKurum;
  @Prop({required: true}) readonly type!: 'alacakli' | 'borclu';
  @Prop({default: false}) readonly isNameMismatch!: boolean;

  get isKurumBilgisiEksik(): boolean {
    if (this.taraf.kisiMi) return false;

    const mersis = this.taraf.temelBilgileri?.mersis;
    const vergiNo = this.taraf.temelBilgileri?.vergiNo;
    const kurumAdi = this.taraf.temelBilgileri?.kurumAdi || this.taraf.kurumAdi;

    const hasMersis = mersis && mersis.trim() !== '';
    const hasVergiNo = vergiNo && vergiNo.trim() !== '';
    const hasKurumAdi = !!kurumAdi;

    return !hasMersis && !hasVergiNo && !hasKurumAdi;
  }
}
